import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * Bounds rich-text page blocks and contains floated images so following blocks
 * (e.g. columns) start below the full text+image area.
 */
export default function PageBlockShell({ children, sx }: Props) {
  return (
    <Box
      sx={[
        {
          width: '100%',
          maxWidth: '100%',
          minWidth: 0,
          boxSizing: 'border-box',
          '&::after': {
            content: '""',
            display: 'table',
            clear: 'both',
          },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Box>
  );
}
